import { FormattedMedia } from '@media/models/formatted-media';

export class ListingsMedia {
    [key: string]: FormattedMedia;
}
